import { createPinia } from "pinia";

import { routerPlugin } from "./plugins/routerPlugin";
const store = createPinia();
store.use(routerPlugin);
export function setupStore(app) {
  app.use(store);
}

export { store };
